import rootEpics from 'epics';
import rootReducer from 'reducers';
import thunk from 'redux-thunk';
import { createEpicMiddleware } from 'redux-observable';
import { panelsHistoryMiddleware } from './middlewares/panelsHistoryMiddleware';
import { saveBomMiddleware } from './middlewares/saveBomMiddleware';
import { saveProjectMiddleware } from './middlewares/saveProjectMiddleware';
import {
  applyMiddleware,
  combineReducers,
  compose,
  createStore,
  AnyAction,
  } from 'redux';
import { sentryReporter } from './middlewares/sentryMiddleware';
import { panelsLimitsMiddleware } from './middlewares/panelsLimitsMiddleware';
import { addPanelsMiddleware } from './middlewares/addPanels';
import { liteDirtyMiddleware } from './middlewares/liteDirtyMiddleware';

// Properly type the epic middleware for Redux-Observable 2.0.0
const epicMiddleware = createEpicMiddleware<AnyAction, AnyAction, appState>();
const reducer = combineReducers({ ...rootReducer });

export default (initialState = {}) => {
  const middlewares = [
    thunk,
    epicMiddleware,
    saveBomMiddleware,
    panelsHistoryMiddleware,
    saveProjectMiddleware,
    sentryReporter,
    panelsLimitsMiddleware,
    addPanelsMiddleware,
    liteDirtyMiddleware,
  ];

  const createStoreWithMiddleware = compose(applyMiddleware(...middlewares))(createStore);

  const store = createStoreWithMiddleware(reducer, initialState);
  
  // Run the root epic
  epicMiddleware.run(rootEpics);

  return store;
};
